import '../SideMenu.scss';

import { CountryFlag } from 'utilities/CountryFlag';
import MenuItem from 'components/MenuItem/MenuItem';
import { useServices, useStores } from 'index';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { LanguageType } from 'types/languages';
import { getErrorMessage } from 'utilities/ErrorHelper';

export const LanguageSubmenu = () => {
  const languagesService = useServices().languagesService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  const { data: userLanguage } = useQuery({
    queryKey: ['userLanguage'],
    queryFn: async () => {
      const response = await languagesService.getUserLanguage();
      localStorage.i18nextLng = response;
      return response;
    },
    refetchOnWindowFocus: false,
  });

  const { data: languages } = useQuery({
    queryKey: ['languages'],
    queryFn: languagesService.loadLanguages,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  const setLanguage = useMutation({
    mutationFn: async (languageCode: LanguageType) => {
      await languagesService.changeLanguage(languageCode);
      localStorage.i18nextLng = languageCode;
      window.location.reload();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['userLanguage'] });
    },
    onError: (ex) => notificationsStore.addToast('error', getErrorMessage(ex), 'error'),
  });

  const handleSetLanguage = (languageCode: LanguageType) => {
    if (!setLanguage.isPending) {
      setLanguage.mutate(languageCode);
    }
  };

  return (
    <div className='submenu-container'>
      <div className='submenu-menu'>
        {languages?.map((language) => {
          return (
            <MenuItem
              key={language.countryCode}
              label={language.displayName}
              onClick={() => handleSetLanguage(language.countryCode)}
              isActive={userLanguage === language.countryCode}
              icon={<CountryFlag countryCode={language.countryCode} />}
              isSubmenu
            />
          );
        })}
      </div>
    </div>
  );
};

export default LanguageSubmenu;
